(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["RenderProp"] = factory(require("react"));
	else
		root["RenderProp"] = factory(root["React"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_3__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var hasOwn = Object.prototype.hasOwnProperty;

var compareOne = function compareOne(a, b, keys) {
  while (keys.length) {
    if (a == null || b == null) return a !== b;
    var key = keys.shift();
    if (key !== '[]') {
      a = a[key];
      b = b[key];
    } else {
      if (!keys.length && a === b) return false;

      var countA = 0;
      var countB = 0;

      for (var _key in a) {
        if (hasOwn.call(a, _key)) countA++;
      }for (var _key2 in b) {
        if (hasOwn.call(b, _key2)) countB++;
      }if (countA !== countB) return true;

      for (var _key3 in a) {
        if (compareOne(a[_key3], b[_key3], keys.slice())) return true;
      }
      return false;
    }
  }
  return a !== b;
};

var compare = function compare(a, b) {
  var comparison = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ['[]'];

  if (typeof comparison === 'function') return !!comparison(a, b);
  if (typeof comparison === 'string') comparison = [comparison];
  if (!(comparison instanceof Array)) {
    console.warn('compare(...): Called with invalid arguments');
  }

  for (var i in comparison) {
    var keys = comparison[i].replace('{}', '[]').split('.');
    if (compareOne(a, b, keys)) return true;
  }
  return false;
};

exports.default = compare;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compare = exports.Store = exports.RenderProp = undefined;

var _RenderProp = __webpack_require__(2);

var _RenderProp2 = _interopRequireDefault(_RenderProp);

var _Store = __webpack_require__(4);

var _Store2 = _interopRequireDefault(_Store);

var _compare = __webpack_require__(0);

var _compare2 = _interopRequireDefault(_compare);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RenderProp2.default;
exports.RenderProp = _RenderProp2.default;
exports.Store = _Store2.default;
exports.compare = _compare2.default;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _compare = __webpack_require__(0);

var _compare2 = _interopRequireDefault(_compare);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RenderProp = function (_React$Component) {
  _inherits(RenderProp, _React$Component);

  function RenderProp() {
    _classCallCheck(this, RenderProp);

    var _this = _possibleConstructorReturn(this, (RenderProp.__proto__ || Object.getPrototypeOf(RenderProp)).call(this));

    _this.mounted = false;
    _this.subscriptions = [];


    if ((this instanceof RenderProp ? this.constructor : void 0) === RenderProp) {
      console.warn('RenderProp(...): RenderProp is an abstract class! You need to extend it.');
    }

    var reactLifecycleMethods = {
      componentWillMount: 'willMount',
      componentDidMount: 'didMount',
      componentWillRecieveProps: 'willRecieveProps',
      shouldComponentUpdate: 'shouldUpdate',
      componentWillUpdate: 'willUpdate',
      componentDidUpdate: 'didUpdate',
      componentWillUnmount: 'willUnmount',
      componentDidCatch: 'didCatch'
    };

    for (var reactMethod in reactLifecycleMethods) {
      var ourMethod = reactLifecycleMethods[reactMethod];
      if ((this instanceof RenderProp ? this.constructor : void 0).prototype.hasOwnProperty(reactMethod)) {
        console.warn('RenderProp(...): Please rename ".' + reactMethod + '" to ".' + ourMethod + '"');
      }
    }

    _this.subscribeTo = _this.subscribeTo.bind(_this);
    return _this;
  }

  _createClass(RenderProp, [{
    key: 'subscribeTo',
    value: function subscribeTo(store, callback, stateChanged) {
      if (!this.mounted) {
        console.warn('RenderProp(...): Cannot use ".subscribeTo" in an unmounted component. Have you tried using ".didMount"?');
        return;
      }

      var prevState = store.getState();
      function callbackWithEqualityCheck() {
        var nextState = store.getState();
        if ((0, _compare2.default)(prevState, nextState, stateChanged)) {
          prevState = nextState;
          callback();
        } else {
          prevState = nextState;
        }
      }

      var unsubscribe = store.subscribe(stateChanged ? callbackWithEqualityCheck : callback);
      this.subscriptions.push(unsubscribe);
      callback();
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.willMount) this.willMount();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted = true;
      if (this.didMount) this.didMount();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.willReceiveProps) this.willReceiveProps(nextProps);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.shouldUpdate) return this.shouldUpdate(nextProps, nextState);else return true;
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      if (this.willUpdate) this.willUpdate(nextProps, nextState);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.didUpdate) this.didUpdate(prevProps, prevState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.willUnmount) this.willUnmount();

      this.mounted = false;
      this.subscriptions.forEach(function (unsubscribe) {
        return unsubscribe();
      });
    }
  }, {
    key: 'componentDidCatch',
    value: function componentDidCatch() {
      if (this.didCatch) this.didCatch();
    }
  }, {
    key: 'render',
    value: function render() {
      var render = this.props.render || this.props.children;
      var state = this.state || {};

      if (render instanceof _react2.default.Component) {
        var Component = render;
        return _react2.default.createElement(Component, state);
      } else if (typeof render === 'function') {
        return render(state);
      } else {
        console.warn('RenderProp(...): ".render" prop is missing or invalid');
        return null;
      }
    }
  }]);

  return RenderProp;
}(_react2.default.Component);

exports.default = RenderProp;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Store = function () {
  function Store(reducer, initalState) {
    _classCallCheck(this, Store);

    this.reducer = function () {};

    this.state = undefined;
    this.listeners = {};

    this.reducer = reducer;
    this.state = initalState;

    this.subscribe = this.subscribe.bind(this);
    this.dispatch = this.dispatch.bind(this);
    this.getState = this.getState.bind(this);
  }

  _createClass(Store, [{
    key: "subscribe",
    value: function subscribe(callback) {
      var _this = this;

      var id = Math.random().toString().slice(2);

      this.listeners[id] = callback;
      var unsubscribe = function unsubscribe() {
        return delete _this.listeners[id];
      };
      return unsubscribe;
    }
  }, {
    key: "dispatch",
    value: function dispatch(action) {
      var listeners = this.listeners;
      this.state = this.reducer(this.state, action);
      for (var k in listeners) {
        listeners[k]();
      }
    }
  }, {
    key: "getState",
    value: function getState() {
      return this.state;
    }
  }]);

  return Store;
}();

exports.default = Store;

/***/ })
/******/ ]);
});
//# sourceMappingURL=render-prop.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/render-prop/build/render-prop.js
// module id = 1
// module chunks = 0